import { Link } from "react-router-dom";
import PublicLayout from "../../components/marketing/PublicLayout";
import { useMarketingLang } from "../../lib/useMarketingLang";
import { IMG } from "../../i18n/marketingImages";
import { ArrowRight, Anchor } from "lucide-react";

export default function MarketingFleet() {
  const { t } = useMarketingLang();
  return (
    <PublicLayout>
      <section className="relative min-h-[380px] flex items-end">
        <img src={IMG.hero} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1A2B]/95 via-[#0F1A2B]/70 to-[#0F1A2B]/30" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-16 lg:py-20 w-full">
          <div className="text-xs uppercase tracking-[0.42em] text-[#ECC974] mb-3">{t.fleet.eyebrow}</div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-4xl">
            {t.fleet.title}
          </h1>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 lg:px-8 py-14">
        <div className="text-xl font-semibold text-[#A57F39] mb-4">{t.fleet.intro1}</div>
        <p className="text-[#0F1A2B]/80 leading-relaxed mb-4">{t.fleet.intro2}</p>
        <p className="text-[#0F1A2B]/80 leading-relaxed mb-4">{t.fleet.intro3}</p>
        <p className="text-[#0F1A2B]/80 leading-relaxed">{t.fleet.intro4}</p>
        <Link
          to="/book"
          data-testid="fleet-check-avail"
          className="inline-flex items-center gap-2 mt-6 rounded-full bg-[#A57F39] hover:bg-[#BD984D] transition text-white uppercase tracking-widest text-xs font-bold px-6 py-3"
        >
          {t.fleet.checkAvail} <ArrowRight className="h-4 w-4" />
        </Link>
      </section>

      <section className="bg-[#F8F7F2] py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <h2 className="text-3xl font-bold text-[#0F1A2B] mb-2">{t.fleet.chooseTitle}</h2>
          <p className="text-[#0F1A2B]/70 mb-8">{t.fleet.chooseSub}</p>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { img: IMG.gl33square, key: "gl33", to: "/baater/greenline-33", testid: "fleet-boat-33" },
              { img: IMG.gl39square, key: "gl39", to: "/baater/greenline-39", testid: "fleet-boat-39" },
            ].map((b) => (
              <Link
                key={b.key}
                to={b.to}
                data-testid={b.testid}
                className="group block rounded-2xl overflow-hidden border border-[#A57F39]/20 bg-white shadow-sm hover:shadow-2xl transition"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={b.img} alt="" className="h-full w-full object-cover group-hover:scale-105 transition duration-700" />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-[#0F1A2B] mb-2 flex items-center gap-2">
                    <Anchor className="h-5 w-5 text-[#A57F39]" /> {t[b.key].title}
                  </h3>
                  <p className="text-sm text-[#0F1A2B]/70 mb-4 leading-relaxed">{t[b.key].subtitle}</p>
                  <ul className="space-y-1.5 text-sm text-[#0F1A2B]/85 mb-4">
                    {t[b.key].specs.slice(0, 6).map((s, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#A57F39] mt-1">✓</span> {s}
                      </li>
                    ))}
                  </ul>
                  <span className="inline-flex items-center gap-2 text-[#A57F39] font-semibold text-sm">
                    {t.fleet.bookNow} <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
